// extracted by mini-css-extract-plugin
export default {"base":"components-MainMenu-themes-BGH-RD3-styles__base--utiUT"};